import { loadingAsyncState } from 'widgets-for-react'
import { DataLayer } from '../../../utils/datalayer'
import { canSafelyCast, TypeCastingValidator } from '../../../utils/safe-type-casting'

const countDataValidator: TypeCastingValidator<number> = {
  kind: 'number',
}

export const loadCount = (
  apicall: () => Promise<any>,
  dataLayerData?: { tab: string; term: string }
) =>
  loadingAsyncState(() =>
    apicall().then((raw) => {
      const maybeTotalCountData = canSafelyCast<number>(countDataValidator, raw)
      if (dataLayerData !== undefined) {
        if (maybeTotalCountData.kind == 'r' && maybeTotalCountData.v <= 0)
          DataLayer.noSearchResults(dataLayerData.tab, dataLayerData.term)
      }
      return maybeTotalCountData.kind == 'r'
        ? {
            kind: 'result',
            value: maybeTotalCountData.v,
            status: 200,
          }
        : {
            kind: 'failed',
            status: 404,
          }
    })
  )
